import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import Home from './pages/Home';
import CanadaPage from './pages/CanadaPage';
import USAPage from './pages/USAPage';
import UKPage from './pages/UKPage';
import BuyCoins from './pages/BuyCoins';
import SellCoins from './pages/SellCoins';
import Collection from './pages/Collection';
import About from './pages/About';
import Contact from './pages/Contact';
import Auctions from './pages/Auctions';
import Services from './pages/Services';
import SyntheticCoins from './pages/SyntheticCoins';
// Import the authentication pages
import Login from './pages/Authentication/Login';
import Register from './pages/Authentication/Register';

function App() {
  return (
    <Router>
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/canada" element={<CanadaPage />} />
          <Route path="/usa" element={<USAPage />} />
          <Route path="/uk" element={<UKPage />} />
          <Route path="/buy" element={<BuyCoins />} />
          <Route path="/sell" element={<SellCoins />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/auctions" element={<Auctions />} />
          <Route path="/services" element={<Services />} />
          <Route path="/synthetic-coins" element={<SyntheticCoins />} />
          {/* Add authentication routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;